module.exports = __webpack_public_path__ + "static/6-ccea71c54a1c86098e9e406ce8b8aaec.jpg";